// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"39f492d4","568":"39f492d4"}[chunkId] + ".chunk.css";
};